import 'modern-normalize/modern-normalize.css';
import './src/css/main.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import CleanUrls from './src/components/CleanUrls';

config.autoAddCss = false;

require('prismjs/themes/prism-okaidia.css');

export const onClientEntry = () => {};

// ブラウザでのレンダリング時に CleanUrls コンポーネントをラップする
export const wrapPageElement = ({ element }) => {
  return (
    <>
      <CleanUrls />
      {element}
    </>
  );
};

// ルート変更時にhead要素の順序を再調整
export const onRouteUpdate = () => {
  // 少し遅延を入れてDOMが更新された後に実行
  setTimeout(() => {
    try {
      const head = document.head;
      if (head) {
        // タイトルタグを最上部に移動
        const title = head.querySelector('title');
        if (title && title !== head.firstElementChild) {
          head.insertBefore(title, head.firstElementChild);
        }

        // descriptionとkeywordsのmetaタグをtitleの直後に移動
        const descriptionMeta = head.querySelector('meta[name="description"]');
        const keywordsMeta = head.querySelector('meta[name="keywords"]');

        if (descriptionMeta && title) {
          // descriptionをtitleの直後に移動
          if (descriptionMeta.previousElementSibling !== title) {
            head.insertBefore(descriptionMeta, title.nextElementSibling);
          }
        }

        if (keywordsMeta && descriptionMeta) {
          // keywordsをdescriptionの直後に移動
          if (keywordsMeta.previousElementSibling !== descriptionMeta) {
            head.insertBefore(keywordsMeta, descriptionMeta.nextElementSibling);
          }
        }

        // その他のmetaタグをstyleタグより上に移動（より安全な方法）
        const metaTags = head.querySelectorAll('meta, link');
        const styleTags = head.querySelectorAll('style');

        if (metaTags.length > 0 && styleTags.length > 0) {
          const firstStyleTag = styleTags[0];

          // metaタグを逆順で処理して、styleタグの前に移動
          const metaTagsArray = Array.from(metaTags).reverse();
          metaTagsArray.forEach((metaTag) => {
            if (metaTag.parentNode === head && metaTag.nextElementSibling === firstStyleTag) {
              // 既に正しい位置にある場合はスキップ
              return;
            }

            // metaタグをstyleタグの前に移動
            if (metaTag.parentNode === head) {
              head.insertBefore(metaTag, firstStyleTag);
            }
          });
        }
      }
    } catch (error) {
      // エラーが発生した場合はコンソールにログを出力（開発時のみ）
      if (process.env.NODE_ENV === 'development') {
        console.warn('onRouteUpdate error:', error);
      }
    }
  }, 100);
};
